import BaseModel from '@/utils/model'
import {
    RFQ_STATUS,
} from '@/utils/const'
/**
 * 询价管理 询价单基础数据
 */
export default class RfqBasicFormData extends BaseModel {

    //TODO 写好注释
    /**
     * 字段id
     */
    id = 0
    name = ''
    code = ''
    parentId = ''
    parentName = 'XXXXXXXXXXXXXXXX'
    parentNodePath = ''
    tenantId = ''
    tenantName = ''
    projectId = ''
    projectName = ''
    projectCode = ''
    technicalCode = ''
    taskCode = ''
    rfqCode = ''
    feeCode = ''
    submitor = ''
    rfqCreateTime = ''
    rfqStopTime = ''
    rfqName = ''
    priceBit = ''
    /**报价截至日期 */
    quotationStopTime = null

    rfqStatus = RFQ_STATUS.RFQSTART
    // get _rfqDisplayStatus() {
    //     return ''
    // }
    delayTimes = 0
    times = 0
    supplyResponsor = ''
    techResponsor = ''
    qualityResponsor = ''   
    carType = ''
    deleteFlag = 0
    purchaseOrgCode = ''
    subcompanyId = ''
    remark = ''
}
